<template>
  <CSDialog v-model="showDialog" persistent position="top">
    <CSCard style="width: 700px" v-if="message.exceptionType === 'Business'">
      <CSCardSection class="row items-center no-wrap">
        <CSCardSection>
          <div class="text-center text-subtitle1">{{ message.title }}</div>
          <ul>
            <li
              v-for="item in message.detailList"
              :key="item"
              class="text-caption"
            >
              {{ item }}
            </li>
          </ul>
          <div v-if="message.exceptionReference">
            Reference: {{ message.exceptionReference }}
          </div>
        </CSCardSection>

        <q-space />

        <CSButton
          :class="mapSeverityToStyleClass(message.severity)"
          class="q-mx-sm"
          icon="close"
          round
          @click="onDismiss"
        />
      </CSCardSection>
    </CSCard>
    <CSCard style="width: 700px; max-width: 80vw" v-else>
      <CSCardSection :class="mapSeverityToStyleClass(message?.severity)">
        <div class="text-h6 text-center">{{ message?.severity }}</div>
      </CSCardSection>

      <q-separator />

      <CSCardSection>
        <div class="text-subtitle1">{{ message?.title }}</div>
        <ul>
          <li class="text-subtitle2" v-for="item in message?.detailList">
            {{ item }}
          </li>
        </ul>
        <div v-if="message.exceptionReference">
          Reference: {{ message.exceptionReference }}
        </div>
      </CSCardSection>

      <q-separator inset />

      <CSCardSection>
        <div class="row q-mb-sm">
          <q-space />

          <CSButton
            round
            style="height: fit-content"
            flat
            dense
            :icon="expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
            @click="expanded = !expanded"
            :color="mapSeverityToColor(message?.severity)"
          />
        </div>
        <q-separator />
        <q-slide-transition>
          <div v-show="expanded">
            <CSCardSection class="text-subtitle2">
              <div v-if="message.detail" class="row">
                <span class="text-weight-medium" style="width: 150px">
                  Detail:
                </span>
                <span class="col">
                  <pre v-if="typeof message.detail === 'object'">{{
                    JSON.stringify(JSON.parse(message.detail), undefined, 2)
                  }}</pre>
                  <span v-else>{{ message.detail }}</span>
                </span>
              </div>
              <!-- <div class="row">
                <span class="text-weight-medium" style="width: 150px">
                  Message Id:
                </span>
                <span class="col ellipsis">
                  {{ message.messageId }}
                </span>
              </div> -->
              <!-- <div class="row">
                <span class="text-weight-medium" style="width: 150px">
                  Date:
                </span>
                <span class="col ellipsis">
                  {{ formatDateTime(message.createdDT) }}
                </span>
              </div> -->
            </CSCardSection>
          </div>
        </q-slide-transition>
      </CSCardSection>

      <CSCardActions align="right">
        <CSButton
          :class="mapSeverityToStyleClass(message.severity)"
          label="Dismiss"
          @click="onDismiss"
        />
      </CSCardActions>
    </CSCard>
  </CSDialog>
</template>

<script setup lang="ts">
import { PropType, ref } from "vue";

import CSDialog from "@/components/CharitySystem/CSDialog.vue";
import CSCard from "@/components/CharitySystem/CSCard.vue";
import CSCardSection from "@/components/CharitySystem/CSCardSection.vue";
import CSCardActions from "@/components/CharitySystem/CSCardActions.vue";
import CSButton from "@/components/CharitySystem/CSButton.vue";

import { ApiException } from "@/api/ResponseModel";
import { formatDateTime } from "@/shared/helperFunctions";
import store from "@/store";

const props = defineProps({
  message: { type: Object as PropType<ApiException>, required: true },
});

const showDialog = ref(true);
const expanded = ref(false);

function mapSeverityToStyleClass(severity?: string) {
  switch (severity) {
    case "Error":
      return ["text-white", "bg-negative"];
    case "Warning":
      return ["bg-warning"];
    case "Information":
      return ["bg-info"];
    default:
      return [];
  }
}

function mapSeverityToColor(severity?: string) {
  switch (severity) {
    case "Error":
      return "negative";
    case "Warning":
      return "warning";
    case "Information":
      return "info";
    default:
      return "";
  }
}

function onDismiss() {
  store.commit("mutRemoveMessage", props.message.title);
  showDialog.value = false;
}
</script>
